export default __webpack_public_path__ + "images/c3a8553d2aadc3f80df77e85480e9b95.png";